module.exports = Object.freeze({
  linkPreview: 'ed6fd093539b20a56e06bc4793a4ddaf',
  tinyMCE: process.env.VUE_APP_TINY_EDITOR_API_KEY || 'biu225bbwau8igqwtb52r9pepqfu5ycn6uhj1cdg2bv71aum', // https://www.tiny.cloud/docs/integrations/vue/#tinymcevuejsintegrationquickstartguide
})
